/**
 * QUOTATION THUNKS — i cinque thunk CRUD standard, dal factory condiviso.
 *
 * Dove il preventivo vive già in un plugin i thunk sono scritti a mano, perché
 * precedono `createCrudThunks`; qui si usa il factory, come tutte le altre
 * entità core.
 *
 * ## Perché il prefisso è `quotations` e non `quotations`
 *
 * Il factory deriva gli action type dal nome (`quotations/fetchAll`, …) e
 * `quotations/fetchAll` è già in uso. Con lo stesso prefisso i due slice
 * reagirebbero l'uno alle azioni dell'altro — `addCase` confronta **stringhe**,
 * non identità di thunk — e il preventivo core si ritroverebbe in state i dati
 * dell'altro, o viceversa. Come per la chiave dello slice, il prefisso torna a
 * `quotations` allo step 12 di TS-87.
 */

import { createCrudThunks } from '../../store/createCrudThunks';
import { quotationApi } from './quotationApi';
import type { Quotation } from './quotationMappers';
import type {
  QuotationCreatePayload,
  QuotationUpdatePayload,
  QuotationListParams,
} from './quotationTypes';

const thunks = createCrudThunks<
  Quotation,
  QuotationCreatePayload,
  QuotationUpdatePayload,
  QuotationListParams
>('quotations', quotationApi);

export const quotationThunks = thunks;
export const {
  fetchAll: fetchQuotations,
  fetchOne: fetchQuotation,
  create: createQuotation,
  update: updateQuotation,
  remove: deleteQuotation,
} = thunks;
